import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { generatePreview } from 'utils';

import './BikeCardRating.css';

class BikeCardRating extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    bike: PropTypes.object.isRequired,
    showProvider: PropTypes.bool
  };

  static defaultProps = {
    showProvider: true
  };

  render() {
    const { t, bike, showProvider } = this.props;

    return (
      <div className="clearfix bike-card-provider-and-rating">
        {showProvider && (
          <div>
            <h6>{t('Provider')}:</h6>

            <span>
              <img
                src={generatePreview(bike.company.logo, 30, 30)}
                alt={bike.company.name}
                title={bike.company.name}
                className="bike-card-provider"
              />
            </span>
          </div>
        )}

        {!!bike.company.rating && (
          <div>
            <h6>{t('Rating')}:</h6>

            <span>
              <span className="bike-card-rating">
                {bike.company.rating}
              </span>
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default translate(['translation'])(BikeCardRating);



// WEBPACK FOOTER //
// ./src/widgets/BikeCard/BikeCardRating.js